import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { IMaterial } from '../models/materials';

@Injectable({
    providedIn: 'root'
})
export class MaterialEquipmentService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getBuildingMaterials(buildingId: string): Observable<{has_error: boolean, message: string; data: IMaterial[]}> {
        const url = environment.apiBaseUrl + endpoints.getBuildingMaterialsAndEquipment.replace(':buildingId', buildingId);

        return this.http.get<{has_error: boolean, message: string; data: IMaterial[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createMaterial(buildingId: string, data: IMaterial): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.createMaterialAndEquipment.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    updateMaterial(buildingId: string, materialId: string, data: IMaterial): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.editMaterialAndEquipment
            .replace(':buildingId', buildingId)
            .replace(':materialId', materialId+'');

        return this.http.put<{has_error: boolean, message: string, data: any}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    approveBuildingMaterials(buildingId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.approveBuildingMaterialsAndEquipment.replace(':buildingId', buildingId);

        return this.http.post<{has_error: boolean, message: string, data: any}>(url, {}).pipe(
            catchError(this.errorService.handleError)
        );
    }

    deleteMaterial(buildingId: string, materialId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteMaterialAndEquipment
            .replace(':buildingId', buildingId)
            .replace(':materialId', materialId);

        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
}